import { createSlice } from "@reduxjs/toolkit";
import _map from 'lodash/map';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import {
  getConversations,
  getConversation,
  updateConversation,
  setDevMode,
  clearLocalConversations,
  clearLocalActiveConversation
} from './actions';

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  conversation: { 
    id: '',
    channel: '',
    mode: '',
    trigger: '',
    orchestrate: false 
  },
  devMode: false,
  loading: { 
    all: false, 
    conversation: false,
    updateConversation: false
  } 
};

const  slice = createSlice({
  name: 'conversations',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getConversations.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getConversations.fulfilled, (state, action) => {
        const { data: { conversations, pagination }, source } = action.payload;
        const defaultConversation = _filter(conversations, { channel: source });

        state.loading.all = false;
        state.all.data = conversations;
        state.all.pagination = pagination;
        state.conversation = defaultConversation[0];
      })
      .addCase(getConversations.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getConversation.pending, (state) => {
        state.loading.conversation = true;
      })
      .addCase(getConversation.fulfilled, (state, action) => {
        const { conversation } = action.payload;
        const foundedConversation = !!_find(state.all.data, (c) => c.id === conversation.id);
        const data = _map(state.all.data, (item) => item.id === conversation.id ? { ...item, ...conversation } : item);

        state.loading.conversation = false;
        if (foundedConversation) {
          state.all.data = data;
          state.conversation = conversation;
        }
      })
      .addCase(getConversation.rejected, (state) => {
        state.loading.conversation = false;
      })
      .addCase(updateConversation.pending, (state) => {
        state.loading.conversation = true;
        state.loading.updateConversation = true;
      })
      .addCase(updateConversation.fulfilled, (state, action) => {
        const { status, conversation } = action.payload;
        const updatedConversation = { ...state.conversation, ...conversation };
        const data = _map(state.all.data, (item) => item.id === conversation.id ? { ...item, ...conversation } : item);

        state.loading.conversation = false;
        state.loading.updateConversation = false;
        if (status === 204) {
          state.all.data = data;
          state.conversation = updatedConversation;
        }
      })
      .addCase(updateConversation.rejected, (state) => {
        state.loading.conversation = false;
        state.loading.updateConversation = false;
      })
      .addCase(setDevMode, state => {
        state.devMode = !state.devMode
      })
      .addCase(clearLocalConversations, state => {
        state.all = initialState.all;
        state.devMode = false;
      })
      .addCase(clearLocalActiveConversation, state => {
        state.conversation = initialState.conversation;
      })
  }
})

export default slice.reducer;